exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logs-container .p-button{background:#293642;border:1px solid #293642}.logs-container .p-datatable .p-sortable-column.p-highlight{background:#969696;color:#fff}.title-cont{padding:2em}.title-cont h2{color:#2a3642}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1320e927","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/pages/admin/Logs.vue
// module id = 513
// module chunks = 0